module.exports = __webpack_public_path__ + "img/130.7.b51252bb.png";